export default __webpack_public_path__ + "static/media/right_bg.6c94b848.png";